import { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useHistory, Link } from 'react-router-dom'
import { useAuth } from 'src/contexts/auth.context'
import { useNotification } from 'src/contexts/notification.context'
import { isClass } from 'src/tools'
import { ErrorField, InputField } from 'src/components/formik'
import {
  getChildrenRequest,
  getChildDetailsRequest,
  createChildRequest,
  updateChildRequest,
  deleteChildRequest,
} from 'src/services/api.service'
import ChildModal from './components/modal'
import StudentRow from './components/student-row'

const initialValues = {
  id: null,
  first_name: '',
  // last_name: '',
  // email: '',
  username: '',
  age: 6,
  password: '',
  // location: ''
}

const ChildSchema = Yup.object().shape({
  first_name: Yup.string().required('Required'),
  username: Yup.string().required('Required'),
  age: Yup.string().required('Required'),
  password: Yup.string().min(6),
})

const ChildrenPage = () => {
  const { user, state } = useAuth()
  const history = useHistory()
  const { showErrorHelper, showConfirm } = useNotification()
  const [loading, setLoading] = useState([])
  const [items, setItems] = useState([])
  const [selItem, setSelItem] = useState(null)
  const [error, setError] = useState(null)
  const [isShowStudentsModal, setIsShowStudentsModal] = useState(false)

  const formik = useFormik({
    initialValues,
    validationSchema: ChildSchema,
    onSubmit: async (values) => {
      try {
        console.log({ values })
        const { id, ...rest } = values
        const response = id
          ? await updateChildRequest(id, rest)
          : await createChildRequest(rest)
        console.log(response)
        await fetchData()
        setIsShowStudentsModal(false)
      } catch (error) {
        formik.setFieldError('username', error?.response?.data?.error)
        setError(error?.response?.data?.error)
      }
    },
  })

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await getChildrenRequest()
      setItems(response.data.items)
    } catch (error) {
      showErrorHelper(error)
    }
    setLoading(false)
  }

  const handleAddChild = () => {
    formik.setValues(initialValues)
    formik.resetForm()
    setIsShowStudentsModal(true)
  }

  const handleEditClick = (item) => () => {
    setSelItem(item)
    const { id, first_name, age, username } = item
    formik.setValues({ id, first_name, age, username, password: '' })
    setIsShowStudentsModal(true)
  }

  const handleDeleteClick = (item) => () => {
    showConfirm({
      title: 'Are you sure?',
      body: `Do you really want to delete the ${item.first_name}?`,
      actions: {
        onOk: async () => {
          await deleteChildRequest(item.id)
          fetchData()
        },
      },
    })
  }

  return (
    <>
      <h2 className="sectionHb-title">Students</h2>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          <div className="row">
            <div className="col-lg-9 col-md-6 col-sm-6" />
            <div className="col-lg-3 col-md-6 col-sm-6 pb-30">
              <button
                onClick={handleAddChild}
                type="button"
                className="btn col-sm-12"
              >
                + Add child
              </button>
            </div>
          </div>

          <div className="details-table">
            <div className="details-table__row details-table__top">
              <div className="details-table__col details-table__col-1" />
              <div className="details-table__col details-table__col-2">
                Student name
              </div>
              <div className="details-table__col details-table__col-3">
                Practices
              </div>
              <div className="details-table__col details-table__col-4">
                Test
              </div>
              <div className="details-table__col details-table__col-5">
                Score
              </div>
              <div className="details-table__col details-table__col-6">
                Progress
              </div>
              <div className="details-table__col details-table__col-7">
                Help
              </div>
            </div>

            {items.map((item) => (
              <StudentRow
                key={item.id}
                item={item}
                onEditClick={handleEditClick(item)}
                onDeleteClick={handleDeleteClick(item)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* <!-- Modals --> */}
      <div
        className={`mask__modal ${isClass(isShowStudentsModal, 'active')}`}
      />

      <ChildModal active={isShowStudentsModal}>
        <form
          onSubmit={formik.handleSubmit}
          action="/"
          name="letterForm"
          id="letterForm"
          className="letter__form"
        >
          <div className="modals__wrapper">
            <div className="modals__head">
              <h3 className="modals__title">Add Child</h3>
              <button
                onClick={() => {
                  setIsShowStudentsModal(false)
                }}
                type="button"
                className="modals__close"
              >
                <img src="/account/images/dest/icons/close.svg" alt="Close" />
              </button>
            </div>

            <div className="modals__body" style={{ display: 'block' }}>
              <div className="row">
                <div className="col-md-6">
                  <div className="cabinet__intro__title">
                    <span className="blue__text">First name</span>
                  </div>
                  <InputField
                    name="first_name"
                    placeholder="First name"
                    formik={formik}
                  />
                </div>
                <div className="col-md-6">
                  <div className="cabinet__intro__title">
                    <span className="blue__text">Username</span>
                  </div>
                  <InputField
                    name="username"
                    placeholder="Username"
                    formik={formik}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="cabinet__intro__title">
                    <span className="blue__text">Age</span>
                  </div>
                  <InputField name="age" placeholder="6" formik={formik} />
                </div>
                <div className="col-md-6">
                  <div className="cabinet__intro__title">
                    <span className="blue__text">Password</span>
                  </div>
                  <InputField
                    name="password"
                    placeholder="Password"
                    formik={formik}
                  />
                </div>
              </div>
            </div>

            <div className="modals__footer">
              <div className="modals__btn__wrapper">
                <button type="submit" className="btn modals__btn">
                  Ok
                </button>
                <button
                  onClick={() => {
                    setIsShowStudentsModal(false)
                  }}
                  type="submit"
                  className="btn modals__btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </ChildModal>
    </>
  )
}

export default ChildrenPage
